import * as React from 'react';
import { Button } from 'semantic-ui-react';
import { decode } from 'he';
import Link from '../../Link';
import NestedMobileMenuPane from './MobileMenuPane';
import InlineSvg from '../../InlineSvg';

class MobileMenuPane extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeSubPane: null,
    };

    this.setActiveSubPane = this.setActiveSubPane.bind(this);
    this.setInactiveSubPane = this.setInactiveSubPane.bind(this);
  }

  setActiveSubPane(index) {
    this.setState({
      activeSubPane: index,
    });
  }

  setInactiveSubPane() {
    this.setState({
      activeSubPane: null,
    });
  }

  render() {
    const {
      childItems,
      index,
      label,
      url,
      classes,
      menuAcf,
      activePane,
      setActivePane,
      setInactivePane,
    } = this.props;

    const { activeSubPane } = this.state;
    // Display sub-menu view if this is the active pane
    if (activePane === index) {
      return (
        <div className="mobile-nav__pane">
          {activeSubPane === null && (
            <div className="mobile-nav__pane-header">
              <button
                className="mobile-nav__back-button"
                onClick={() => setInactivePane()}
              >
                <InlineSvg
                  name="chevron-left-alt"
                  color="cobalt"
                  className="mobile-nav__back-icon"
                />
                Back
              </button>
              {menuAcf && menuAcf.menuIcon && menuAcf.menuIcon.sourceUrl && (
                <img
                  src={menuAcf.menuIcon.sourceUrl}
                  alt={decode(label)}
                  className="mobile-nav__pane-image"
                />
              )}
              <h3 className="mobile-nav__pane-title">
                <Link to={url}>{decode(label)}</Link>
              </h3>
            </div>
          )}
          <div className="mobile-nav__pane-wrapper">
            {childItems &&
              childItems.map((item, i) => {
                return (
                  <NestedMobileMenuPane
                    key={i}
                    index={i}
                    label={item.label}
                    activePane={activeSubPane}
                    setActivePane={this.setActiveSubPane}
                    setInactivePane={this.setInactiveSubPane}
                    url={item.url}
                    menuAcf={item.menuAcf}
                    classes={item.classes}
                    childItems={item.childItems ? item.childItems : []}
                  />
                );
              })}
          </div>
        </div>
      );
      // Display the regular menu item if there are no active panes
    } else if (activePane === null) {
      return (
        <div className="mobile-menu__menu-item">
          {childItems && childItems.length > 0 ? (
            <Button
              className={`mobile-menu__sub-menu-button ${
                classes && classes.includes('bold')
                  ? 'mobile-menu__sub-menu-button--bold'
                  : ''
              }`}
              onClick={() => setActivePane(index)}
            >
              {menuAcf && menuAcf.menuIcon && menuAcf.menuIcon.sourceUrl && (
                <img src={menuAcf.menuIcon.sourceUrl} alt={decode(label)} />
              )}
              {decode(label)}
              <InlineSvg name="chevron-right" color="brand-secondary" />
            </Button>
          ) : (
            <Link
              to={url}
              className={`mobile-menu__menu-link ${
                classes && classes.includes('bold')
                  ? 'mobile-menu__menu-link--bold'
                  : ''
              }`}
            >
              {menuAcf && menuAcf.menuIcon && menuAcf.menuIcon.sourceUrl && (
                <img src={menuAcf.menuIcon.sourceUrl} alt={decode(label)} />
              )}
              {decode(label)}
            </Link>
          )}
        </div>
      );
      // Return nothing if something else is the active pane (hide this menu item)
    } else {
      return null;
    }
  }
}

export default MobileMenuPane;
